import React, { useContext } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import SignupPage from "../../src/ui/Pages/SignupPage";
import UserHeader from "../customComponents/UserHeader";
import Footer from "../customComponents/Footer";
import LandingPage from "../ui/Pages/LandingPage";
import LoginPage from "../ui/Pages/LoginPage";
import ForgotPassword from "../ui/Pages/ForgotPassword";
import ProfilePage from "../ui/Pages/ProfilePage";
import ComingSoonPage from "../ui/Pages/ComingSoonPage";
import AuthHeader from "../customComponents/AuthHeader";
import Trade from "../ui/Pages/TradePage";
import Market from "../ui/Pages/Market";
import Funds from "../ui/Pages/Funds";
import NotificationPage from "../ui/Pages/NotificationPage";
import { ProfileContext } from "../context/ProfileProvider";
import Termsofuse from "../ui/Pages/Termsofuse";
import AmlPolicy from "../ui/Pages/AmlPolicy";
import Contactus from "../ui/Pages/Contactus";
import FeesPage from "../ui/Pages/FeesPage";
import ListCoin from "../ui/Pages/ListCoin";
import ReferalPage from "../ui/Pages/ReferalPage";
import SecuritySystem from "../ui/Pages/SecuritySystem";
import RefrealList from "../ui/Pages/RefrealList";
import BlogList from "../ui/Pages/Blog/BlogList";
import MobileChart from "../ui/Pages/MobileChart";
import BlogDetails from "../ui/Pages/Blog/BlodDetails";
import SettingsPage from "../ui/Pages/SettingsPage";
import SupportPage from "../ui/Pages/Support";
import TwofactorPage from "../ui/Pages/TwofactorPage";
import SecurityPage from "../ui/Pages/SecurityPage";
import ActivitylogPage from "../ui/Pages/ActivitylogPage";
import CurrencyPrefrence from "../ui/Pages/CurrencyPrefrence";
import Dashboard from "../ui/Pages/Dashboard";
import AssetOverview from "../ui/Pages/AssetOverview";
import SpotOrders from "../ui/Pages/SpotOrders";
import TransactionHistory from "../ui/Pages/TransactionHistory";
import OpenOrders from "../ui/Pages/OpenOrders";
import SidebarDeposit from "../customComponents/SidebarDeposit";
import DepositPage from "../ui/Pages/DepositPage";
import WithdrawPage from "../ui/Pages/WithdrawPage";
import MemePage from "../ui/Pages/MemePage";
import KycPage from "../ui/Pages/KycPage";
import Swap from "../ui/Pages/Swap";
import RiskDisclosure from "../ui/Pages/RiskDisclosure";
import PrivacyDataProtectionPolicy from "../ui/Pages/PrivacyDataProtectionPolicy";
import ComplaintsHandlingProcedure from "../ui/Pages/ComplaintsHandlingProcedure";
import GeneralDisclaimer from "../ui/Pages/GeneralDisclaimer";
import FAQSidebar from "../ui/Pages/FAQ/FAQSidebar";
import FAQ from "../ui/Pages/FAQ";
import RegistrationVerification from "../ui/Pages/RegistrationVerification";
import RegistrationResult from "../ui/Pages/RegistrationResult";
import QuickBuySellHistory from "../ui/Pages/QuickBuySellHistory";
import InternalWalletTransHistory from "../ui/Pages/InternalWalletTransHistory";
import AnnouncementDetails from "../ui/Pages/AnnouncmentManagement/AnnouncementDetails";
import Announcement from "../ui/Pages/AnnouncmentManagement/Announcement";
import P2pDashboard from "../ui/Pages/P2P/P2pDashboard";
import P2pOrderDetails from "../ui/Pages/P2P/P2pOrderDetails";
import P2pCreatePost from "../ui/Pages/P2P/P2pCreatePost";
import P2pMyAds from "../ui/Pages/P2P/P2pMyAds";
import P2pOrders from "../ui/Pages/P2P/P2pOrders";
import P2pProfile from "../ui/Pages/P2P/P2pProfile";
import Earning from "../ui/Pages/Earning";
import EarningPlanHistory from "../ui/Pages/EarningPlanHistory";
import CopyTrading from "../ui/Pages/CopyTrading";
import MasterDetail from "../ui/Pages/CopyTrading/MasterDetail";

function Routing() {
  const location = useLocation();
  const token = sessionStorage.getItem("token");
  const { userDetails } = useContext(ProfileContext);
  const isChartPage = location?.pathname?.includes('/chart');
  const isLoginPage = location?.pathname?.includes('/login');
  const isSignupPage = location?.pathname?.includes('/signup');
  const isOptionPage = location?.pathname?.includes('/options');
  const isFuturesPage = location?.pathname?.includes('/usd_futures');
  const isDashboardPages = location?.pathname?.includes('/user_profile');
  const isAssetPages = location?.pathname?.includes('/asset_managemnet');
  const isForgotPass = location?.pathname?.includes('/forgot_password');
  const accountVerification = location?.pathname?.includes('/account-verification');
  const accountActivate = location?.pathname?.includes('/account-activate');
  const isComingSoonPage = location?.pathname === '/*';
  const isP2pPage = location?.pathname?.includes('/p2p-');

  return (
    <>
      {isChartPage ? null : token ? <AuthHeader userDetails={userDetails} /> : <UserHeader />}
      <Routes>
        <Route exact path="/" element={<LandingPage />} />
        <Route path="/user_profile" element={token ? (<ProfilePage userDetails={userDetails} />) : (<Navigate to="/login" replace state={{ redirectTo: location.pathname }} />)} >
          <Route element={token ? (<SettingsPage userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
          <Route index path="dashboard" element={token ? (<Dashboard userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
          <Route path="asset_overview" element={token ? (<AssetOverview userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
          <Route path="swap_history" element={token ? (<QuickBuySellHistory userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
          <Route path="spot_orders" element={token ? (<SpotOrders userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
          <Route path="transaction_history" element={token ? (<TransactionHistory userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
          <Route path="wallet_transfer_History" element={token ? (<InternalWalletTransHistory userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
          <Route path="earning_plan_history" element={token ? (<EarningPlanHistory userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />

          <Route path="open_orders" element={token ? (<OpenOrders userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
          <Route path="profile_setting" element={token ? (<SettingsPage userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
          <Route path="kyc" element={token ? (<KycPage userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
          <Route path="notification" element={token ? (<NotificationPage userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
          <Route path="two_factor_autentication" element={token ? (<TwofactorPage userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
          <Route path="password_security" element={token ? (<SecurityPage userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
          <Route path="activity_logs" element={token ? (<ActivitylogPage userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
          {/* <Route path="arbitrage_bot" element={token ? (<ArbitrageBot userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
          <Route path="arbitrage_dashboard" element={token ? (<ArbitrageDashboard userDetails={userDetails} />) : (<Navigate to="/login" replace />)} /> */}
          <Route path="swap" element={token ? (<Swap userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
          <Route path="support" element={token ? (<SupportPage userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
          <Route path="support" element={token ? (<SupportPage userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
          <Route path="currency_preference" element={token ? (<CurrencyPrefrence userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
          {/* <Route path="user_kyc" element={token ? (<AutomatedKyc userDetails={userDetails} />) : (<Navigate to="/login" replace />)} /> */}
        </Route>

        <Route path="/asset_managemnet" element={token ? (<SidebarDeposit userDetails={userDetails} />) : (<Navigate to="/login" replace />)} >
          <Route index path="deposit" element={token ? (<DepositPage userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
          <Route path="withdraw" element={token ? (<WithdrawPage userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
        </Route>
        {/* <Route path="/kyc" element={token ? (<KycPage userDetails={userDetails} />) : (<Navigate to="/login" replace />)} /> */}
        <Route path="/funds_details" element={token ? (<Funds userDetails={userDetails} />) : (<Navigate to="/login" replace />)} />
        {/* <Route path="/launchpad" element={token ? <Launchpad /> : <Navigate to="/login" replace />} /> */}
        <Route path="/referal_list" element={token ? <RefrealList /> : <Navigate to="/login" replace />} />



        <Route exact path="/forgot_password" element={<ForgotPassword />} />
        <Route exact path="/signup" element={!token ? <SignupPage /> : <Navigate to="/user_profile/dashboard" replace />} />
        <Route exact path="/account-verification/:authenticationToken" element={!token ? <RegistrationVerification /> : <Navigate to="/user_profile/dashboard" replace />} />
        <Route exact path="/account-activate/:authenticationToken" element={!token ? <RegistrationResult /> : <Navigate to="/user_profile/dashboard" replace />} />
        <Route exact path="/login" element={!token ? <LoginPage /> : <Navigate to="/user_profile/dashboard" replace />} />
        <Route exact path="/market" element={<Market />} />

        <Route exact path="/meme" element={<MemePage />} />
        <Route exact path="/trade" element={<Navigate to="/trade/BTC_USDT" replace />} />
        <Route exact path="/trade/:pairs" element={<Trade />}></Route>
        <Route exact path="/notification" element={<NotificationPage />} />
        <Route exact path="/general-disclaimer" element={<GeneralDisclaimer />} />
        <Route exact path="/RiskDisclosure" element={<RiskDisclosure />} />
        <Route exact path="/TermsofUse" element={<Termsofuse />} />
        <Route exact path="/aml-kyc-policy" element={<AmlPolicy />} />
        <Route exact path="/blogdetails" element={<BlogDetails />}></Route>
        <Route exact path="/PrivacyDataProtectionPolicy" element={<PrivacyDataProtectionPolicy />} />
        <Route exact path="/complaints-handling-procedure" element={<ComplaintsHandlingProcedure />} />
        <Route exact path="/contact" element={<Contactus />} />
        <Route exact path="/fees" element={<FeesPage />} />
        <Route exact path="/coin_list" element={<ListCoin />} />
        <Route exact path="/refer_earn" element={<ReferalPage />} />
        <Route exact path="/security_system" element={<SecuritySystem />} />
        <Route exact path="/blogs" element={<BlogList />} />
        <Route exact path="/earning" element={<Earning />} />
        <Route exact path="/copy-trading" element={<CopyTrading />} />
        <Route exact path="/copy-trading/:masterId" element={<MasterDetail />} />

        <Route exact path="/FAQ" element={<FAQ />}></Route>
        <Route exact path="/FAQSidebar" element={<FAQSidebar />}></Route>
        <Route exact path="/" element={<LandingPage />} />
        <Route path="/chart/:theme/:pairs" element={<MobileChart />} />
        <Route path="/announcement" element={<Announcement />} />
        <Route path="/announcement_details/:title/:announce_title_id" element={<AnnouncementDetails />} />
        {/* P2P Routes */}
        <Route path="/p2p-dashboard" element={token ?<P2pDashboard /> : <Navigate to="/login" replace />} />
        <Route path="/p2p-order-details/:adId" element={token ?<P2pOrderDetails /> : <Navigate to="/login" replace />} />
        <Route path="/p2p-create-post" element={token ?<P2pCreatePost /> : <Navigate to="/login" replace />} />
        <Route path="/p2p-my-ads" element={token ?<P2pMyAds /> : <Navigate to="/login" replace />} />
        <Route path="/p2p-orders" element={token ?<P2pOrders /> : <Navigate to="/login" replace />} />
        <Route path="/p2p-profile" element={token ?<P2pProfile /> : <Navigate to="/login" replace />} />
        <Route path="/*" element={<ComingSoonPage />} />
      </Routes>
      {isChartPage || isLoginPage || isSignupPage || isDashboardPages || isAssetPages || isComingSoonPage || isForgotPass || accountVerification || accountActivate || isFuturesPage || isOptionPage || isP2pPage ? null : <Footer />}
    </>
  );
}

export default Routing;
